import { render } from "./LogoutComponent.vue?vue&type=template&id=3aa08ea5&scoped=true"
const script = {}

import "./LogoutComponent.vue?vue&type=style&index=0&id=3aa08ea5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa08ea5"]])

export default __exports__